import { render, staticRenderFns } from "./DeleteRow.vue?vue&type=template&id=52872214"
import script from "./DeleteRow.vue?vue&type=script&lang=js"
export * from "./DeleteRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports